import React, { useEffect, useState } from 'react';
import { XCloseIcon } from '../../icons';
import { twMerge } from 'tailwind-merge';
import './modal.css';
import '@/components/modals/modal-buttons.css';
import { JWModalProps } from '../../../utils/types';

/** Nested JWModals share one body lock; only the first open applies padding, last close clears it. */
let modalBodyScrollLockCount = 0;

function JWModal(props: JWModalProps) {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (!props.show) {
            return undefined;
        }

        modalBodyScrollLockCount += 1;
        if (modalBodyScrollLockCount === 1) {
            const scrollbarWidth =
                window.innerWidth - document.documentElement.clientWidth;
            if (scrollbarWidth > 0) {
                document.body.style.paddingRight = `${scrollbarWidth}px`;
            }
            document.body.style.overflow = 'hidden';
            document.body.classList.add('modal-open');
        }

        return () => {
            modalBodyScrollLockCount -= 1;
            if (modalBodyScrollLockCount <= 0) {
                modalBodyScrollLockCount = 0;
                document.body.style.paddingRight = '';
                document.body.style.overflow = '';
                document.body.classList.remove('modal-open');
            }
        };
    }, [props.show]);

    const handleBackdropClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        props.onClose();
        if (props.setShow) {
            props.setShow(false);
        }
    };

    // Apply different classes based on device type
    const modalClasses = isMobile
        ? 'modal-wrapper modal-center-mobile fixed flex flex-col z-[10000] rounded-lg border border-solid !border-darkgray p-[12px] font-sans w-[95%] max-w-full'
        : 'modal-wrapper fixed flex flex-col z-[10000] top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4 rounded-lg border border-solid !border-darkgray p-[12px] font-sans';

    return (
        props.show ?
            <>
                <div
                    className={twMerge(modalClasses, props.wrapperClassName)}
                    onClick={(e) => {
                        e.stopPropagation();
                        // Prevent event bubbling to backdrop
                        e.nativeEvent.stopImmediatePropagation();
                    }}
                >
                    {/* HEADER */}
                    <header className="flex shrink-0 justify-between items-center mb-3">
                        {props.title ? (
                            <div className="flex-1">
                                <h1 className="text-2xl font-bold text-black">{props.title}</h1>
                            </div>
                        ) : (
                            <div className="flex-1" />
                        )}
                        <div className="flex justify-end">
                            <button
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    props.onClose();
                                }}
                                className="p-1.5 border border-aquarius rounded-full cursor-pointer h-7 w-7 flex items-center justify-center"
                            >
                                <XCloseIcon width={14} height={14} />
                            </button>
                        </div>
                    </header>
                    {/* DETAILS */}
                    {props.children}
                </div>

                {/* modal backdrop is used to fade the content behind modal */}
                <div id="modalBackdrop" className="modal-backdrop" onClick={handleBackdropClick} />
            </>
            :
            <></>
    );
}

export default JWModal;
